import type { FaireProductEntity } from "../../entity_types/product";

export const p_5vw86mwyvp: FaireProductEntity = {
  token: "p_5vw86mwyvp",
  type: "product",
  name: "LM-SP-1000 Sherpa - Cream/Light Pink",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/fe827b99a5d238b02cd0c073be92cb9052fb6eb8062173d8e8eae2c5b5b35f17.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce5e197604f389a87f76907cccc02e62a7af85d59852eeb5a64ef473f53e8820.jpeg"
  ],
  priceDollars: 39.5,
  description: "This Sherpa pullover from Girlie Girl Originals in cream and light pink offers casual comfort and feminine style. Designed for layering, it provides warmth and a relaxed fit, bringing a refined touch to women's fleece apparel.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:49.083Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
